module.exports = {
      id: "vikatanspl-usage",
      viewBox: "0 0 30.9 32",
      url: "/" + "sprite-906bd948b42f12135087bdf480fde2e1.svg#vikatanspl",
      toString: function () {
        return this.url;
      }
    }